import * as React from 'react';
import DiMarkdown from './DiMarkdown';

function GptCompanyMessage({ message} :any) {
  return (
    <div>
      <div className="page-header">
        <h3 className="page-title"> </h3>
        <nav aria-label="breadcrumb">
          <ol className="breadcrumb">
            <li className="breadcrumb-item"><a href="/">Home</a></li>
            <li className="breadcrumb-item active" aria-current="page">{message.header}</li>
          </ol>
        </nav>
      </div>
      <div className="row">
        <div className="col-lg-12">
          <div className="card">
            <div className="card-body col-lg-9 col-md-4">
              <div className="faq-section">
                <div className="container-fluid bg-gradient-success py-2">
                  <p className="mb-0 text-white">{message.header}</p>
                </div>
                <div className="accordion">
                  <div className="card">
                    <div className="card-header" id="headingOne">
                      <h5 className="mb-0">
                        <strong>
                          <DiMarkdown>{message.title}</DiMarkdown>
                        </strong>
                        <p>{message.created_at}</p>
                      </h5>
                    </div>
                    <div id="collapseOne" className="collapse show">
                      <div className="card-body">
                        <p>
                          <DiMarkdown>{message.content}</DiMarkdown>
                        </p>
                        <p>
                          <strong>Source:</strong> <a href={message.source_url}>Decode Investing AI Assistant</a>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default GptCompanyMessage;
